import React, { useEffect, useState } from "react";
import { htmlPrint } from "./htmlPrinter";
import { xmlPrint } from "./xmlPrinter";
import HCPrint from "./hardWareControllerPrinter";
import { kotPrinter } from "./kotPrinter";
import { v4 as uuidv4 } from "uuid";
import CWHCPrint from "./CWHardwareController";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import useRestaurantStore from "../../stores/useRestaurantStore";

const PrintController = (receiptData, cart) => {
  const tillData = useAuthStore.getState().tillData;
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;
  const isPrintModeXML = tillData.tillAccess.cwrTill.hardwareController.printReceipt === "Y" ? true : false;
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const posConfig = usePOSConfigStore.getState().posConfig;
  if (useRestaurantStore.getState().dineIn === "N") {
    const printKOTArray = cart.items.reduce((result, current) => {
      const category = current.productionCenter;
      if (!result[category]) {
        result[category] = [];
      }
      result[category].push(current);
      return result;
    }, {});
    if (posConfig?.enableKOTPrint === "Y" && !CWHardwareController) {
      kotPrinter(printKOTArray, cart, "receipt");
    }
    setTimeout(() => {
      if (ObFlag) {
        HCPrint(receiptData);
      } else if (CWHardwareController) {
        CWHCPrint(receiptData);
      } else if (isPrintModeXML) {
        xmlPrint(receiptData, "Receipt");
      } else {
        htmlPrint(receiptData, "Receipt");
      }
    }, 1000);
  } else {
    if (ObFlag) {
      HCPrint(receiptData);
    } else if (CWHardwareController) {
      CWHCPrint(receiptData);
    } else if (isPrintModeXML) {
      xmlPrint(receiptData, "Receipt");
    } else {
      htmlPrint(receiptData, "Receipt");
    }
  }
};
export default PrintController;
